import wrapper from 'wrapper';

const ASCENDING = 1;
const DESCENDING = -1;

export default class Sort {
    constructor(root) {
        this.root = root;
        this.headers = Array.prototype.slice.call(this.root.querySelectorAll('.sortable'));
        this.fallbackSortColumn = 'location';

        this.setupListeners();

        const initialSortHeader = this.root.querySelector('.sortable[data-column=total]');
        const initialSortOrder = DESCENDING;
        this.sortByHeader(initialSortHeader, initialSortOrder);
    }

    setupListeners() {
        this.headers.forEach(header => {
            header.addEventListener('click', (e) => {
                e.preventDefault();
                this.sortByHeader(header);
                wrapper.trackUserAction('sort-table', `${this.sortColumn} ${this.sortOrder === 1 ? 'ASC' : 'DESC'}`);
            });
        });
    }

    resetHeaders() {
        this.headers.forEach(header => {
            header.classList.remove('sorted--asc');
            header.classList.remove('sorted--desc');
        });
    }

    sortByHeader(header, order) {
        this.resetHeaders();
        this.setSort(header.dataset.column, order);

        const className = this.sortOrder === ASCENDING ? 'sorted--asc' : 'sorted--desc';
        header.classList.add(className);
    }

    setSort(column, order) {
        if (order) {
            this.sortOrder = order;
        }
        else if (column === this.sortColumn) {
            this.sortOrder = -this.sortOrder;
        }
        this.sortColumn = column;
        this.applySort();
    }

    applySort() {
        if (!!window.MSInputMethodContext && !!document.documentMode) {
            this.applySortIE();
            return;
        }
        const parent = this.root.querySelector('tbody');
        const nodes = parent.querySelectorAll('.row');
        const children = Array.prototype.slice.call(nodes);

        parent.innerHTML = '';
        children.sort(this.getSortHandler()).forEach(child => parent.appendChild(child));
        window.dispatchEvent(new CustomEvent('updated-sort', { detail: this.sortColumn }));
    }

    applySortIE() {
        // IE doesn't like writeable table elements, so we have to recreate the table at every sort
        const nodes = this.root.querySelectorAll('.row');
        const children = Array.prototype.slice.call(nodes);

        const table = document.createElement('table');
        const thead = this.root.querySelector('thead');
        const tbody = document.createElement('tbody');

        children.sort(this.getSortHandler()).forEach(child => tbody.appendChild(child));
        table.appendChild(thead);
        table.appendChild(tbody);
        this.root.parentNode.replaceChild(table, this.root);
        this.root = table;
        window.dispatchEvent(new CustomEvent('updated-sort', { detail: this.sortColumn }));
    }

    getSortHandler() {
        if (this.sortColumn === 'location') {
            return this.stringSort.bind(this);
        }
        return this.numberSort.bind(this);
    }

    fallbackSort(a, b) {
        if (this.sortColumn === this.fallbackSortColumn) {
            // If all else is the same, sort by location
            const x = a.dataset.location;
            const y = b.dataset.location;

            if (x > y) {
                return this.sortOrder;
            }
            if (x < y) {
                return -this.sortOrder;
            }
            return 0;
        }

        const x = a.dataset[this.fallbackSortColumn];
        const y = b.dataset[this.fallbackSortColumn];

        return (x - y) * this.sortOrder;
    }

    numberSort(a, b) {
        const x = a.dataset[this.sortColumn];
        const y = b.dataset[this.sortColumn];

        const comparison = (x - y) * this.sortOrder;
        if (comparison === 0) {
            return this.fallbackSort(a, b);
        }
        return comparison;
    }

    stringSort(a, b) {
        const x = a.dataset[this.sortColumn];
        const y = b.dataset[this.sortColumn];

        if (x > y) {
            return this.sortOrder;
        }
        if (x < y) {
            return -this.sortOrder;
        }
        return this.fallbackSort(a, b);
    }
}
